"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyShape = void 0;
const validation_1 = require("../validation");
var BodyShape;
(function (BodyShape) {
    BodyShape["MALE"] = "BaseMale";
    BodyShape["FEMALE"] = "BaseFemale";
    BodyShape["ZOMBIE"] = "BaseZombie";
    BodyShape["APE"] = "BaseApe";
    BodyShape["ALIEN"] = "BaseAlien";
    BodyShape["JUSTIN_SUN"] = "BaseJustinSun";
    BodyShape["TRON_BEAR"] = "BaseTronBear";
    BodyShape["TRON_WHALE"] = "BaseTronWhale";
    BodyShape["MOON_MAN"] = "BaseMoonMan";
    BodyShape["MAMBA"] = "BaseMamba";
    BodyShape["HOOD"] = "BaseHood";
    BodyShape["MUSHROOM_MAN"] = "BaseMushroomMan";
})(BodyShape = exports.BodyShape || (exports.BodyShape = {}));
(function (BodyShape) {
    BodyShape.schema = {
        type: 'string',
        enum: Object.values(BodyShape),
    };
    BodyShape.validate = validation_1.generateValidator(BodyShape.schema);
})(BodyShape = exports.BodyShape || (exports.BodyShape = {}));
//# sourceMappingURL=body-shape.js.map